import * as React from "react"
import type { SVGProps } from "react"
const SvgDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 13.32 3.9-3.9a1 1 0 0 1 .7-.28q.45 0 .7.28a1 1 0 0 1 .29.7 1 1 0 0 1-.28.7l-4.6 4.6q-.15.15-.33.22a1 1 0 0 1-.37.06 1 1 0 0 1-.38-.06 1 1 0 0 1-.33-.21l-4.6-4.61a1 1 0 0 1-.28-.7 1 1 0 0 1 .28-.7 1 1 0 0 1 .7-.28q.42 0 .7.28z" />
  </svg>
)
export default SvgDown
